<template>
  <v-card class="py-2 pl-4 pr-2 mt-3 elevation-2">
    <v-layout>
      <v-flex xs7 class="align-center d-flex">
          <div
            class="horiz-left-coloured-bg"
          >
              <v-icon color="secondary" :class="severity" class="mt-1 pt-1 ml-2 horiz-left-coloured-bg--icon">{{icon}}</v-icon>
          </div>
          <v-flex pl-3 ml-3>
          <h3 v-if="notification.link" class="h-100">
            <span class="mr-2" style="padding-right:4px">{{notification.title}}</span>
             <a href="#" class="no-link-style" v-if="isFileLink" @click="viewFile()">
        {{notification.linkText}}
            </a>
            <a
              :href="notification.link"
              class="no-link-style d-inline-block"
              style="font-weight:500;"
              v-else
            >  <span class="icon-bold-link">{{notification.linkText}}</span></a>
          </h3>

          <h3  class="icon-bold-link" v-else>
            <span class="mr-1" style="padding-right:4px">{{notification.title}}</span>
          </h3>
          <h4 v-if="notification.message">
            <span class="body-1 opacity-54">{{notification.message}}</span>
          </h4>
          </v-flex>
      </v-flex>
      <v-flex xs5 text-xs-right class="mt-0">
        <v-btn
          icon
          small
          class="mr-3 mt-0"
          v-if="expandable"
          @click="expandDetail = !expandDetail"
          style="margin-top:6px !important;background-color:#e9e9e9 !important;"
        >
          <v-icon color="secondary">{{ expandDetail ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <div
            slot="activator"
            class="body-1 opacity-54"
            style="display:inline-flex; vertical-align:top !important; margin-top:13px; cursor: pointer;"
          >{{timestamp}}</div>
          <span>{{fullDate}}</span>
        </v-tooltip>
        <v-btn @click="clearNotification()" icon  style="margin-right:-2px;">
          <v-icon color="error">cancel</v-icon>
        </v-btn>
        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="mr-0 ml-0 pa-0"
              icon
              @click.prevent>
              <v-icon color="secondary">more_vert</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-tile v-if="caseSubs" @click="disableNotifications()">
              <v-icon class="mr-2" color="secondary">notifications_off</v-icon>Turn off notifications on this case
            </v-list-tile>
            <v-list-tile v-if="caseId" :to="{ path: casePreferencesRoute(caseId)}">
              <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications on this case
            </v-list-tile>
            <v-list-tile v-else :to="{ path: userPreferencesRoute(userId)}">
              <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-slide-y-transition v-if="expandable">
      <v-card-text v-if="notification.fileAttachmentId" v-show="expandDetail" class="pt-3 px-0">
        <!-- Card media -->
        <v-img class="mb-0" width="100%" src="https://picsum.photos/810/400?random"></v-img>
      </v-card-text>
      <v-card-text v-if="notification.jobId" v-show="expandDetail" class="pt-3 px-0">
        <!-- Card media -->
        <v-layout wrap>
          <ul class="timeline-updates-list" style="list-style:none">
            <li>
              <h4>
                <div style="font-weight:400; display:inline-block" class="mr-1">Status</div>was changed from
                <i style="font-weight:400;">Pending</i> to
                <i style="font-weight:400; color:green">Completed</i>.
              </h4>
            </li>
          </ul>
        </v-layout>
      </v-card-text>
      <v-card-text v-if="notification.messageId" v-show="expandDetail" class="pt-3 px-0">
        <!-- Card media -->
        <div class="elevation-0 pa-4 ma-0 mb-2" style="background:#f6f6f6; border-radius:3px;">
          <v-list-tile-title class="caption">
            To:
            <span>steven@caseblocks.com, andrew@caseblocks.com</span>
          </v-list-tile-title>
          <v-list-tile-title class="caption">From: matthew@caseblocks.com</v-list-tile-title>
          <v-list-tile-title class="caption">Subject: convo subject ...</v-list-tile-title>
          <div class="pt-4">
            <p>Vivamus a dolor nec tellus tincidunt laoreet nec ac odio. Vestibulum sodales accumsan ligula. Nunc est odio, sodales vel gravida eget, commodo sed ante. Sed cursus quis lorem vitae porttitor. Pellentesque quis odio non orci pretium ultricies. Aliquam sagittis orci augue, ut ultrices magna mollis vulputate. Proin ultrices vulputate auctor. Vivamus cursus sodales ante. Donec pretium nec massa elementum feugiat. Vestibulum porttitor tincidunt nisi, nec finibus mi consectetur in. In ornare, nisi et porta pulvinar, lacus mauris efficitur eros, non malesuada enim justo sed dolor.</p>
            <p>Nulla et purus vel metus lobortis semper eu vel sem. Donec tempus est sed mauris dapibus, at dapibus ligula accumsan. Phasellus vel congue leo, ac suscipit enim. Curabitur id cursus velit. Integer vestibulum metus vitae elit faucibus egestas. Cras dapibus commodo nibh, a laoreet nulla dapibus et. Donec eget eros tristique, sagittis orci at, placerat metus. Cras vitae volutpat libero. In nec nisi porttitor, sagittis erat nec, tincidunt ante.</p>
          </div>
        </div>
      </v-card-text>
    </v-slide-y-transition>
    <v-flex class="severity-border" :class="severity"></v-flex>
  </v-card>
</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
export default {
  name: "notification",
  props: { notification: Object, icon: String },
  data: () => ({
    expandDetail: false,
    viewing: false
  }),
  computed: {
    ...mapState({
      timePref: state =>
        state &&
        state.currentUser &&
        state.currentUser.me &&
        state.currentUser.me.preferences &&
        state.currentUser.me.preferences.dateTimeFormat
          ? state.currentUser.me.preferences.dateTimeFormat
          : "HH:MM",
      userId: state => state.currentUser.me.id,
      subscriptions: state => state.currentUser.subscriptions
    }),
    isFileLink() {
      return (this.notification && this.notification.link && this.notification.link.match(/\/documents/))
    },
    caseId() {
      return this.notification.caseId
    },
    caseSubs() {
      if (this.caseId) {
        const subs = this.subscriptions.filter(
          sub => sub.case.id === this.caseId
        )
        if (subs.length > 0) {
          return subs
        } else {
          return undefined
        }
      } else {
        return undefined
      }
    },
    severity() {
      switch (this.notification.severity) {
        case "info":
          return ""
        case "error":
          return "error-notification"
        default:
          return "tertiary-notification"
      }
    },
    timestamp() {
      return Helpers.formatDate(this.notification.createdAt, 'h:mma, Do MMM')
    },
    fullDate() {
      return Helpers.formatDate(this.notification.createdAt, 'dddd, Do MMMM YYYY, h:mma')
    },
    allEvents: {
      get() {
        return (
          this.updateEvent &&
          this.statusEvent &&
          this.taskEvent &&
          this.documentEvent &&
          this.conversationEvent &&
          this.createEvent &&
          this.viewEvent
        )
      },
      set(value) {
        this.updateEvent = value
        this.statusEvent = value
        this.taskEvent = value
        this.documentEvent = value
        this.conversationEvent = value
        this.createEvent = value
        this.viewEvent = value
      }
    },
    expandable() {
      // const attachment = this.notification.fileAttachmentId
      // const job = this.notification.jobId
      // const conversation = this.notification.messageId
      // return (attachment || job || conversation)
      return false
    },
    fileAttachment() {
      return this.notification.fileAttachmentId
    }
  },
  methods: {
    userPreferencesRoute: userId => `/users/${userId}/Notifications`,
    casePreferencesRoute: caseId => `/case/${caseId}/timeline`,
    async disableNotifications() {
      const updateUnSubs = this.caseSubs.map(sub => sub.eventType)
      const success = await this.$store.dispatch("unsubscribeFromCaseEvents", {
        caseId: parseInt(this.caseId),
        eventTypes: updateUnSubs
      })
      if (success) {
        // if all succeeded
        this.$store.commit("displayFlashMessage", {
          message:
            "Successfully cleared all notification subscriptions on case",
          severity: "success"
        })
      }
    },
    async clearNotification() {
      await this.$store.dispatch(
        "clearNotification",
        parseInt(this.notification.id)
      )
    },
    async viewFile() {
      if (!this.viewing) {
        this.viewing = true
        const url = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${this.notification.link}` : this.notification.link
        const auth = "Bearer " + window.localStorage.session

        const anchor = document.createElement("a")
        document.body.appendChild(anchor)
        const headers = new Headers()
        headers.append("Authorization", auth)

        const response = await fetch(url, { headers })
        const blobby = await response.blob()
        const objectUrl = window.URL.createObjectURL(blobby)
        anchor.href = objectUrl
        anchor.target = "blank"
        anchor.click()
        this.viewing = false
      }
    }
  }
}
</script>
